import styled from 'styled-components';

const edaStyle = styled.div`
  #lcEdaCanvas {
    div {
      -moz-user-select: none; /*火狐*/
      -webkit-user-select: none; /*webkit浏览器*/
      -ms-user-select: none; /*IE10*/
      -khtml-user-select: none; /*早期浏览器*/
      user-select: none;
    }
    *[layerid='0']:not([c_para]) {
      stroke: #fff;
    }
    *[layerid='1']:not([c_para]) {
      stroke: #ff0000;
      fill: #ff0000;
    }
    *[layerid='2']:not([c_para]) {
      stroke: #0000ff;
      fill: #0000ff;
    }
    *[layerid='3']:not([c_para]) {
      stroke: #ffff00;
      fill: #ffff00;
    }
    *[layerid='4']:not([c_para]) {
      stroke: #808000;
      fill: #808000;
    }
    *[layerid='5']:not([c_para]) {
      stroke: #808080;
      fill: #808080;
    }
    *[layerid='6']:not([c_para]) {
      stroke: #800000;
      fill: #800000;
    }
    *[layerid='7']:not([c_para]) {
      stroke: #800080;
      fill: #800080;
    }
    *[layerid='8']:not([c_para]) {
      stroke: #aa00ff;
      fill: #aa00ff;
    }
    *[layerid='9']:not([c_para]) {
      stroke: #6464ff;
      fill: #6464ff;
    }
    *[layerid='10']:not([c_para]) {
      stroke: #ff00ff;
      fill: #ff00ff;
    }
    *[layerid='11']:not([c_para]) {
      stroke: rgb(96, 96, 96);
      fill: rgb(96, 96, 96);
    }
    *[layerid='12']:not([c_para]) {
      stroke: #ffffff;
      fill: #ffffff;
    }
    *[layerid='13']:not([c_para]) {
      stroke: #fff;
    }
    *[layerid='14']:not([c_para]) {
      stroke: #fff;
    }
    *[layerid='15']:not([c_para]) {
      stroke: #fff;
    }
    *[layerid='16']:not([c_para]) {
      stroke: #fff;
    }
    *[layerid='17']:not([c_para]) {
      stroke: #fff;
    }
    *[layerid='18']:not([c_para]) {
      stroke: #fff;
    }
    *[layerid='19']:not([c_para]) {
      stroke: #fff;
    }
    *[layerid='20']:not([c_para]) {
      stroke: #fff;
    }
    *[layerid='21']:not([c_para]) {
      stroke: #800000;
      fill: #800000;
    }
    *[layerid='22']:not([c_para]) {
      stroke: #008000;
      fill: #008000;
    }
    *[layerid='23']:not([c_para]) {
      stroke: #00ff00;
      fill: #00ff00;
    }
    *[layerid='24']:not([c_para]) {
      stroke: #000080;
      fill: #000080;
    }
    *[layerid='43']:not([c_para]) {
      stroke: #39503f;
      fill: #39503f;
    }
    *[layerid='44']:not([c_para]) {
      stroke: #0c715d;
      fill: #0c715d;
    }
    *[layerid='45']:not([c_para]) {
      stroke: #5a8a80;
      fill: #5a8a80;
    }
    *[layerid='46']:not([c_para]) {
      stroke: #2b937e;
      fill: #2b937e;
    }
    *[layerid='47']:not([c_para]) {
      stroke: #23999d;
      fill: #23999d;
    }
    *[layerid='48']:not([c_para]) {
      stroke: #45b4e3;
      fill: #45b4e3;
    }
    *[layerid='49']:not([c_para]) {
      stroke: #215da1;
      fill: #215da1;
    }
    *[layerid='50']:not([c_para]) {
      stroke: #4564d7;
      fill: #4564d7;
    }
    *[layerid='51']:not([c_para]) {
      stroke: #6969e9;
      fill: #6969e9;
    }
    *[layerid='52']:not([c_para]) {
      stroke: #9069e9;
      fill: #9069e9;
    }
    *[fill='none'] {
      fill: none;
    }
    *[stroke='none'] {
      stroke: none;
    }
    #g12 path,
    #g12 polyline,
    #g12 polygon,
    #g12 line {
      stroke-linecap: round;
    }
    *[fill='none']:not([c_para]) {
      fill: none;
    }
    *[stroke='none']:not([c_para]) {
      stroke: none;
    }
    #g12 g[c_partid='part_pad'] {
      display: initial;
    }
    #g12 line[c_shapetype='line'] {
      stroke-width: 1;
    }
    #root2 #g12 g[c_partid='part_pad'] > * + circle,
    #gCurParts g[c_partid='part_pad'] > * + circle {
      fill: rgb(34, 34, 34);
    } /* inner hole of pad */
    #root2 #g12 g[c_partid='part_via'] > * + circle:nth-of-type(2),
    #gCurParts g[c_partid='part_via'] > * + circle:nth-of-type(2) {
      fill: rgb(34, 34, 34);
    } /* via */
    #root2 #g12 g[c_partid='part_hole'] > * + circle,
    #gCurParts g[c_partid='part_hole'] > * + circle {
      fill: rgb(34, 34, 34);
    } /* hole */
    #root2 #g12 g[c_partid='part_pad'] > polyline:nth-of-type(2),
    #gCurParts g[c_partid='part_pad'] > polyline:nth-of-type(2) {
      stroke: #000000;
    } /* inner hole of pad */
    #root2 #g12 g[c_partid='part_pad'][c_shape='ELLIPSE'] > polyline:nth-last-of-type(1),
    #gCurParts g[c_partid='part_pad'] > polyline:nth-last-of-type(1) {
      stroke: #000000;
    }
    #root2 #g12 g[c_partid='part_pad'][c_shape='RECT'] > polyline:nth-last-of-type(1),
    #gCurParts g[c_partid='part_pad'] > polyline:nth-last-of-type(1) {
      stroke: #000000;
    }
    #root2 g[c_partid='part_pad'][layerid='1'] ellipse:not([c_padid]) {
      fill: #ff0000;
    }
    #root2 g[c_partid='part_pad'][layerid='1'] polygon:not([c_padid]) {
      fill: #ff0000;
    }
    #root2 g[c_partid='part_pad'][layerid='1'] polyline:not([c_padid]) {
      stroke: #ff0000;
    }
    #root2 g[c_partid='part_pad'][layerid='1'] circle {
      fill: #ff0000;
    }
    #root2 g[c_partid='part_pad'][layerid='2'] ellipse:not([c_padid]) {
      fill: #0000ff;
    }
    #root2 g[c_partid='part_pad'][layerid='2'] polygon:not([c_padid]) {
      fill: #0000ff;
    }
    #root2 g[c_partid='part_pad'][layerid='2'] polyline:not([c_padid]) {
      stroke: #0000ff;
    }
    #root2 g[c_partid='part_pad'][layerid='2'] circle {
      fill: #0000ff;
    }
    #root2 g[c_partid='part_pad'][layerid='11'] ellipse:not([c_padid]) {
      fill: #c0c0c0;
    }
    #root2 g[c_partid='part_pad'][layerid='11'] polygon:not([c_padid]) {
      fill: #c0c0c0;
    }
    #root2 g[c_partid='part_pad'][layerid='11'] polyline:not([c_padid]) {
      stroke: #c0c0c0;
    }
    #root2 g[c_partid='part_pad'][layerid='11'] circle {
      fill: #c0c0c0;
    }
    #root2 g[c_partid='part_pad'][layerid] > circle[c_padhole] {
      fill: #000000;
    }
    #root2 g[c_partid='part_pad'][layerid] > polyline[c_padhole] {
      stroke: #000000;
    }
    #root2 g[c_partid='part_via'][layerid] > * + circle {
      fill: #000000;
    }
    #root2 g[c_partid='part_pad'] > polygon[c_padid] {
      stroke-linejoin: miter;
      stroke-miterlimit: 100;
    }
    #root2 g[c_partid='part_hole'] > circle {
      fill: #c0c0c0;
    }
    path,
    polyline,
    polygon {
      stroke-linejoin: round;
    }
    #g12 circle,
    #g12 ellipse,
    #g12 polyline,
    #g12 line,
    #g12 polygon,
    #g12 path {
      shape-rendering: crispEdges;
    }
    #g12 [stroke-width='1'] {
      stroke-width: 1;
    }
    .px1 {
      stroke-width: 1;
    }
    #g12 .hover:not([fill]),
    #g12 .hover *:not([fill]),
    #g12 .active:not([fill]),
    #g12 .active *:not([fill]),
    #g12 .selected:not([fill]),
    #g12 .selected *:not([fill]) {
      fill: #223;
      fill-opacity: 0.6;
    }
    #g12 .hover:not([stroke]),
    #g12 .hover *:not([stroke]),
    #g12 .active:not([stroke]),
    #g12 .active *:not([stroke]),
    #g12 .selected:not([stroke]),
    #g12 .selected *:not([stroke]) {
      stroke: #fff;
      stroke-opacity: 0.6;
    }
    #g12 g[c_partid='part_pad']:hover > *:not([fill]),
    #g12 g[c_partid='part_pad'].active > *:not([fill]) {
      fill: #222;
    }
    #g12 g[c_partid='part_pad']:hover > *:not([stroke]),
    #g12 g[c_partid='part_pad'].active > *:not([stroke]) {
      stroke: #333;
    }
    #g12 g[c_partid='part_via']:hover > *:not([fill]),
    #g12 g[c_partid='part_via'].active > *:not([fill]) {
      fill: #111;
      fill-opacity: 1;
    }
    #g12 path[attachedcopperid] {
      pointer-events: none;
    }
    text.hover,
    .hover text,
    tspan.hover,
    .hover tspan {
      stroke: none;
      fill: #fff;
    }
    #root2 g[c_partid='part_pad']:hover[layerid='1'] polyline:not([c_padid]) {
      stroke: #fff;
    }
    #root2 g[c_partid='part_pad']:hover[layerid='1'] ellipse:not([c_padid]) {
      fill: #fff;
    }
    #root2 g[c_partid='part_pad']:hover[layerid='1'] polygon:not([c_padid]) {
      fill: #fff;
    }
    #root2 g[c_partid='part_hole']:hover ellipse {
      stroke: #fff;
    }
    #root2 .active polyline:not([c_padid]) {
      stroke: #fff;
    }
    #root2 .active ellipse {
      stroke: #fff;
    }
    #root path,
    #root polyline,
    #root polygon {
      stroke-linejoin: round;
      stroke-linecap: round;
    }
    #root rect,
    #root circle,
    #root ellipse,
    #root polyline,
    #root line,
    #root polygon,
    #root path {
      shape-rendering: initial;
      stroke-linecap: round;
    }
    #g1 circle.pindot {
      fill: none;
      stroke-opacity: 0.5;
      stroke-width: 0.3;
      stroke: #333;
      shape-rendering: auto;
    }
    #gNets > text,
    #gNetsTextRuler {
      text-anchor: middle;
      font-family: Consolas, Courier, Monospace;
    }
    #gNets > text:not([fill]) {
      fill: #fff;
    }
    #gNets > text:not(stroke) {
      stroke: black;
    }
  }
`;

export default edaStyle;
